<template>
  <!-- 订单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Input v-model="searchParams.salesmanName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">质检状态</span>
          <Select v-model="searchParams.qualityStatusList" :transfer="true" clearable multiple>
            <Option value="0">待质检</Option>
            <Option value="1">质检成功</Option>
            <Option value="-1">质检失败</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" v-if="tableData.length">
          <template slot-scope="{ row }" slot="policyNo">
            <a class="table-btn" @click.stop="openDetail(row)">{{ row.policyNo }}</a>
          </template>
          <template slot-scope="{ row }" slot="qualityStatus">
            <span v-if="row.qualityStatus === 0">待质检</span>
            <span v-else-if="row.qualityStatus === 1">质检成功</span>
            <span v-else-if="row.qualityStatus === -1">质检失败</span>
            <span v-else>-</span>
            <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
              <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="row.qualityStatus === -1 && row.remark" />
              <div slot="content">
                <p>{{ row.remark }}</p>
              </div>
            </Poptip>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span v-if="row.signStatus * 1 === 0" class="table-btn" @click="handleBindPolicy(row)">未签单</span>
            <span v-else class="table-btn table-btn-disabled">已签单</span>
          </template>
        </Table>
        <no-data v-else style="margin-top: 250px"></no-data>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
      <!-- 线上保单详情  -->
      <detail-modal ref="detailModal"></detail-modal>

      <!-- 线下保单详情 -->
      <policyDetail ref="policyDetailRef"></policyDetail>

      <!-- 绑定表单 -->
      <Modal v-model="isShowBindPolicyModal" :loading="bindPolicyModalLoading" width="430" title="签单码绑定" @on-ok="bindPolicy">
        <div style="padding-right: 20px;">
          <Form ref="bindPolicyForm" :model="bindPolicyFormData" :label-width="100">
            <FormItem label="保单号">
              {{ bindPolicyFormData.policyNo || '-' }}
            </FormItem>
            <FormItem label="签单码" prop="signCode" :rules="$units.formRule.required('请输入')">
              <Input v-model="bindPolicyFormData.signCode" />
            </FormItem>
          </Form>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import userPoptip from '@/components/commons/userPoptip';
import selectTree from '@/components/system/selectTree3';
import { config } from './comp.config.js';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
import policyDetail from '@/pages/orderManage/insuredOrder/components/policyDetail';

export default {
  components: {
    userPoptip,
    detailModal,
    policyDetail,
    selectTree
  },
  mixins: [pageTool, common, config],
  inject: ['listMode'],
  data() {
    return {
      searchParams: {
        userType: '1'
      },
      isShowBindPolicyModal: false,
      bindPolicyFormData: {
        signCode: ''
      },
      bindPolicyModalLoading: true
    };
  },
  mounted() {
    this.initListAjax('/buz/policy/sign/list');
  },
  activated() {
    this.getList();
  },
  computed: {
    policyType() {
      return this.listMode === 'group' ? '2' : '1';
    }
  },
  methods: {
    handleBindPolicy(row) {
      if (row.signStatus == 1) return;
      this._bindPolicyData = row;
      this.bindPolicyFormData = {
        policyNo: row.policyNo,
        signCode: ''
      };
      this.$refs.bindPolicyForm.resetFields();
      this.isShowBindPolicyModal = true;
    },
    bindPolicy() {
      this.$refs.bindPolicyForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.$http({
          url: '/buz/policy/sign/sign',
          type: 'POST',
          data: {
            ...this.bindPolicyFormData,
            policyNo: this._bindPolicyData.policyNo,
            policyType: this.policyType
          }
        }).then(res => {
          this.$notice.success('绑定成功');
          this.isShowBindPolicyModal = false;
          this.getList();
        });
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'order_1_61_0';
    },
    setListParams(params) {
      this.getColumns(); //获取表格字段
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.applyOrgId;
      params.policyType = this.policyType;
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    openDetail(row) {
      if (this.policyType == 1) {
        if (row.sourceType == 1) {
          this.$refs.detailModal.open(row);
        } else {
          this.$refs.policyDetailRef.open(row);
        }
      } else if (this.policyType == 2) {
        this.$router.push({
          path: '/orderManage/group/policyDetail',
          query: {
            backUrl: this.delQueStr(this.$route.fullPath, 'time'),
            id: row.id || '',
            policyNo: row.policyNo,
            orderNo: row.orderId
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-btn-disabled {
  cursor: no-drop;
  color: #c5c8ce;
}
</style>
